import { Injectable, signal } from '@angular/core'
import { Subject } from 'rxjs'
import { TreeViewItem } from '../sections/tree-section/components/tree-view/tree-view.type'

@Injectable({ providedIn: 'root' })
export class AssetsTreeService {
  public closeDetails$ = new Subject<void>()
  public showDetails$ = new Subject<TreeViewItem>()
  public selectedItem = signal<TreeViewItem | null>(null)
  public hasLocationCreatePermission = signal<boolean>(false)
  public hasEquipmentCreatePermission = signal<boolean>(false)
  public hasEquipmentEditPermission = signal<boolean>(false)
  public hasEquipmentViewPermission = signal<boolean>(false)
  public hasLocationEditPermission = signal<boolean>(false)
  public hasMaintenanceViewPermission = signal<boolean>(false)
}
